import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import {
    ABOUT_BANNER_SIZE,
    ABOUT_BANNER_SIZE_MOBILE,
} from '@modules/professional/config/constants';

export const Banner: StyleRule = ({ theme }) => {
    return {
        width: pxToRem(ABOUT_BANNER_SIZE_MOBILE),
        height: pxToRem(ABOUT_BANNER_SIZE_MOBILE),
        position: `relative`,
        margin: 'auto',
        borderRadius: pxToRem(10),
        overflow: 'hidden',

        [theme.screen.laptop]: {
            margin: 'unset',
            width: pxToRem(ABOUT_BANNER_SIZE),
            height: pxToRem(ABOUT_BANNER_SIZE),
        },
    };
};
